import { Component, OnInit, ViewChild } from "@angular/core";
import { DxFormComponent } from "devextreme-angular";
import { v4 as uuid } from "uuid";
import { ActivatedRoute, Router } from "@angular/router";
import { MessagesService } from "src/app/services/service.index";
import { CompanyService } from "src/app/services/company.service";
import { Theme } from "src/app/models/auth/_models/user.model";
import { ImagenModel } from "src/app/models/auth/_models/ImagenModel";
import { AuthService } from "src/app/models/auth/_services/auth.service";



@Component({
  selector: "app-company-settings",
  templateUrl: "company-settings.component.html",
  styles: [],
})
export class CompanySettingsComponent implements OnInit {
  formId = uuid();
  @ViewChild(DxFormComponent, { static: false }) settingsForm: DxFormComponent;
  saveButtonOptions: any;
  backOptions: any;
  themeData: Theme = new Theme();
  loading = false;
  modeEdit = false;
  isImageVisible: boolean;
  isImageVisiblePos: boolean;
  ListImagePos: any;
  base64textString: string;
  DocumentoCopia: string;
  nameima: string
  imagen: string
Visible=true;
  isImageVisibleSeven: any;
  coloresself= false;

  constructor(
    private companyService: CompanyService,
    public authService: AuthService,

    private router: Router,
    private activatedRoute: ActivatedRoute,
    private _messagesService: MessagesService,
  ) {
    this.isImageVisible = false;
    this.isImageVisiblePos = false;
    this.backOptions = {
      icon: "undo",
      hint: "Atrás",
      onClick: () => {
        this.goback();
      },
    };

    this.saveButtonOptions = {
      icon: "save",
      hint: "Guardar",
      onClick: () => {
        this.save();
      },
    };
  }

  checkBoxSelf(e) {
    this.isImageVisiblePos = false;
    this.isImageVisible = false;
    value: e.value;
    this.isImageVisible = e.component.option('value');
  };


  checkBoxcoloresSelf(e) {
    this.isImageVisiblePos = false;
    this.isImageVisible = false;
    value: e.value;
    this.coloresself = e.component.option('value');
  };

  checkBoxSeven(e) {
    this.isImageVisiblePos = false;
    this.isImageVisible = false;
    value: e.value;
    this.isImageVisibleSeven = e.component.option('value');
  };

  checkBoxPos(e) {
    this.isImageVisible = false;
    this.isImageVisibleSeven = false;
    value: e.value;
    this.isImageVisiblePos = e.component.option('value');
    this.GetImagePos();
  }


  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      const id = params.pId;
      if (id) {
        this.modeEdit = true;
        this.getThemeById(id);
      }
    });
  }

  save() {
    let result = this.settingsForm.instance.validate();
    if (result.isValid) {
      this.loading = true;
      this.companyService.updateTheme(this.themeData).subscribe((result) => {
        this.loading = false;
        if (result.isSuccessful) {
          this._messagesService.success("Hecho!");
        } else {
          this._messagesService.error(result.errorMessage);
        }
      });
    }
  }

  goback() {
    this.router.navigate(["core/companysettings-list"]);
  }

  getThemeById(id: string) {
    this.loading = true;
    this.companyService.getThemeById(id).subscribe((resp) => {
      this.loading = false;
      if (resp.isSuccessful) {
        this.themeData = resp.result;
      }
    });
  }


  updateClick(e, a: string) {
    this.imagen = a;
    let files = e.target.files;
    let file = files[0];

    //this.nameima = e.value[0].name
    this.nameima = e.target.files[0].name;
    if (files && file) {
      let reader = new FileReader();
      reader.onload = this.handleFile.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  handleFile(event) {
    let binaryString = event.target.result;
    this.base64textString = btoa(binaryString);
    this.DocumentoCopia = window.btoa(binaryString);
    event.target.value = null;



    if (this.isImageVisibleSeven) {

      let img: ImagenModel = {
        Imagen: this.DocumentoCopia,
        NombreImagen: this.nameima,
        typeportal:'P'
      }

      this.companyService.postImageSelf(img).subscribe((resp) => {
        if (resp) {
          let elemento: any = document.getElementById(this.imagen);
          elemento.disabled = "True";
        } else {
          this._messagesService.error("El archivo " + this.nameima + " no pudo ser guardada, revisa que se tenga una extensión valida");
        }
      })
    }
      

    if (this.isImageVisible) {

      let img: ImagenModel = {
        Imagen: this.DocumentoCopia,
        NombreImagen: this.nameima,
        typeportal:'S'
      }

      this.companyService.postImageSelf(img).subscribe((resp) => {
        if (resp) {
          let elemento: any = document.getElementById(this.imagen);
          elemento.disabled = "True";
        } else {
          this._messagesService.error("El archivo " + this.nameima + " no pudo ser guardada, revisa que se tenga una extensión valida");
        }
      })
    } else if (this.isImageVisiblePos) {
      let img: ImagenModel = {
        Imagen: this.DocumentoCopia,
        NombreImagen: this.nameima,
        typeportal:'P'
      }
      this.companyService.postImagePos(img).subscribe((resp) => {
        if (!resp) {
          this._messagesService.error("El archivo " + this.nameima + " no pudo ser guardada, revisa que se tenga una extensión valida");
        }else{
          this.GetImagePos();
        }
      })
    }
  }

  updateClickPos(e) {

    let files = e.target.files;
    let file = files[0];

    //this.nameima = e.value[0].name
    this.nameima = e.target.files[0].name;
    if (files && file) {
      let reader = new FileReader();
      reader.onload = this.handleFile.bind(this);
      reader.readAsBinaryString(file);
    }
  }

  GetImagePos() {
    this.companyService.getimagePos().subscribe((resp) => {
      if (resp.isSuccessful) {
        this.ListImagePos = resp.result;
      }
    })
  }


}
